import createReducer from 'utils/createReducer';

const UNASSIGNED = ['PENDING_ASSIGNMENT'];
const ASSIGNED = ['ASSIGNED', 'IN_TRANSIT'];
const FINISHED = ['DONE_WITHOUT_MANIFEST', 'DONE', 'CANCELLED', 'DONE_WITH_CANCELLATIONS'];

const SET_UNASSIGNED_FILTER = 'jobs/SET_UNASSIGNED_FILTER';
const SET_ASSIGNED_FILTER = 'jobs/SET_ASSIGNED_FILTER';
const SET_FINISHED_FILTER = 'jobs/SET_FINISHED_FILTER';

// Initial State
const INIT_STATE = {
  filters: {
    unassigned: {
      date: undefined,
      statuses: UNASSIGNED,
      sortingField: '-pickup_time_from',
      groupingField: 'start_time_from',
      dateField: 'pickup_time_from',
    },
    assigned: {
      date: undefined,
      statuses: ASSIGNED,
      sortingField: '-pickup_time_from',
      groupingField: 'start_time_from',
      dateField: 'pickup_time_from',
    },
    finished: {
      date: undefined,
      statuses: FINISHED,
      sortingField: '-delivered_or_cancelled_at',
      groupingField: 'delivered_or_cancelled_at',
      dateField: 'delivered_or_cancelled_at',
    },
  },
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_UNASSIGNED_FILTER](state, payload) {
    return {
      filters: {
        unassigned: {
          ...state.filters.unassigned,
          ...payload,
        },
        assigned: {
          ...state.filters.assigned,
        },
        finished: {
          ...state.filters.finished,
        },
      },
    };
  },
  [SET_ASSIGNED_FILTER](state, payload) {
    return {
      filters: {
        unassigned: {
          ...state.filters.unassigned,
        },
        assigned: {
          ...state.filters.assigned,
          ...payload,
        },
        finished: {
          ...state.filters.finished,
        },
      },
    };
  },
  [SET_FINISHED_FILTER](state, payload) {
    return {
      filters: {
        unassigned: {
          ...state.filters.unassigned,
        },
        assigned: {
          ...state.filters.assigned,
        },
        finished: {
          ...state.filters.finished,
          ...payload,
        },
      },
    };
  },
});

export const setUnassignedFilter = (filters) => ({
  type: SET_UNASSIGNED_FILTER,
  payload: filters,
});

export const setAssignedFilter = (filters) => ({
  type: SET_ASSIGNED_FILTER,
  payload: filters,
});

export const setFinishedFilter = (filters) => ({
  type: SET_FINISHED_FILTER,
  payload: filters,
});
